import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseOperatorPageController';
export default {
    /**
     * 新增地址
     */
    repairPersonalContact: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'repairPersonalContact',
        type: requestType.Post,
    },
    /**
     * 查询外访附件
     */
    queryVisitAttachment: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryVisitAttachment',
        type: requestType.Get,
    },
    /**
     * 分页查询跟进
     */
    caseFollowupRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseFollowupRecord',
        type: requestType.Get,
    },
    /**
     * 增加催收跟进
     */
    addCaseFollowupRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseFollowupRecord',
        type: requestType.Post,
    },
    /**
     * 电话录音查询列表
     */
    caseTelRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseTelRecord',
        type: requestType.Get,
    },
    /**
     * 增加催收总结
     */
    addCaseTelRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseTelRecord',
        type: requestType.Post,
    },
    /**
     * 客户开户信息查询
     */
    personalBankInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'personalBankInfo',
        type: requestType.Get,
    },
    /**
     * 客户联系人信息查询
     */
    personalContacts: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'personalContacts',
        type: requestType.Get,
    },
    /**
     * 客户信息查询
     */
    personalInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'personalInfo',
        type: requestType.Get,
    },
    /**
     * 执行页顶部信息
     */
    topInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'topInfo',
        type: requestType.Get,
    },
    /**
     * 客户房产信息
     */
    queryPersonalHouse: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryPersonalHouse',
        type: requestType.Get,
    },
    /**
     * 客户收支状况查询
     */
    queryPersonalIncome: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryPersonalIncome',
        type: requestType.Get,
    },
    /**
     * 产品信息查询
     */
    queryProduct: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryProduct',
        type: requestType.Get,
    },
    /**
     * 案件信息查询
     */
    queryCaseInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCaseInfo',
        type: requestType.Get,
    },
    /**
     * 共债信息查询
     */
    queryDebtCaseInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryDebtCaseInfo',
        type: requestType.Get,
    },
    /**
     * 案件批注分页查询
     */
    caseRemark: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseRemark',
        type: requestType.Get,
    },
    /**
     * 添加批注
     */
    addCaseRemark: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseRemark',
        type: requestType.Post,
    },
    /**
     * 客户联系人地址信息查询
     */
    queryPersonalAddress: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryPersonalAddress',
        type: requestType.Get,
    },
    /**
     * 查询催收总结
     */
    findCaseTelRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'findCaseTelRecord',
        type: requestType.Get,
    },
    /**
     * 申请历史
     */
    caseApplyHistory: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseApplyHistory',
        type: requestType.Get,
    },
    /**
     * 执行页--通讯录 -- 添加联系人
     */
    addPersonalContact: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'addPersonalContact',
        type: requestType.Post,
    },
    /**
     * 执行页--通讯录 -- 删除联系人
     */
    deletePersonalContact: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'deletePersonalContact',
        type: requestType.Delete,
    },
    /**
     * 执行页--行动区 -- 流转历史
     */
    getAllCaseTurnRecords: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllCaseTurnRecords',
        type: requestType.Get,
    },
    /**
     * 执行页--发送短信
     */
    sendMessage: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'sendMessage',
        type: requestType.Post,
    },
    /**
     * 执行页--发送邮件
     */
    sendMail: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'sendMail',
        type: requestType.Post,
    },
    /**
     * 执行页--获取模板
     */
    getTemplateContent: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTemplateContent',
        type: requestType.Get,
    },
    /**
     * 执行页--还款计划
     */
    queryRepaymentPlan: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryRepaymentPlan',
        type: requestType.Get,
    },
    /**
     * 执行页--附件信息
     */
    queryCaseUploadFile: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCaseUploadFile',
        type: requestType.Get,
    },
    /**
     * 更改风险客户标识
     */
    modifyRiskFlag: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'modifyRiskFlag',
        type: requestType.Get,
    },
    /**
     * 外放总结获取联系人信息
     */
    getPersonalContactInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getPersonalContactInfo',
        type: requestType.Post,
    },
    /**
     * 增加法务催收跟进
     */
    addCaseLegalRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'addCaseLegalRecord',
        type: requestType.Post,
    },
    /**
     * 分页查询法务跟进
     */
    queryCaseLegalRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCaseLegalRecord',
        type: requestType.Get,
    },
    /**
     * 查询最新的未结案的法催记录
     */
    queryUnClossCaseLegalRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryUnClossCaseLegalRecord',
        type: requestType.Get,
    },
    /**
     * 通过id查询法催记录
     */
    queryCaseLegalRecordById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCaseLegalRecordById',
        type: requestType.Get,
    },
    /**
     * 查询执行立案法院名称去重
     */
    queryExecuteCourtName: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryExecuteCourtName',
        type: requestType.Get,
    },
    /**
     * 出入库历史记录
     */
    queryWarehouseChangeRecords: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryWarehouseChangeRecords',
        type: requestType.Get,
    },
    /**
     * 单个附件删除
     */
    deleteCaseUploadFileById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'deleteCaseUploadFileById',
        type: requestType.Get,
    },
    /**
     * 通过案件任务id查看案件当前信息
     */
    getCaseInfoRecordIdById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCaseInfoRecordIdById',
        type: requestType.Get,
    }
};
